require('./bootstrap');
require('./scripts');
require('./welcome');
//require('./tables');
require('./common');
require('./candidates');
require('./schedule');
require('./analitics');
require('./training');
